
import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { getDashbordSummeryRequest } from "../apiRequests/summeryRequest";
import { getDashboardSummeryErrorAction, getDashboardSummerySuccessAction } from "../../actions/getDashbordSummeryAction";




function* dashboardSummerydHandler(action: any) {
    try {

        const response: { data: any } = yield call(getDashbordSummeryRequest, action.payload)

        yield put(
            getDashboardSummerySuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getDashboardSummeryErrorAction({
                error: error
            })
        )

    }
}




function* watcherDashboardSummerySaga() {
    yield all([takeLatest(Types.GET_DASHBOARD_SUMMERY_REQUEST, dashboardSummerydHandler)]);

}

export default watcherDashboardSummerySaga